import "../job-timeline/JobTimeline.scss";
import "./AppliedJobs.scss";

import { useEffect, useState } from "react";
import Job, { JobInfo } from "../../../../../components/job/Job";
import { JobApiRoutes } from "../../../../../shared/api-routes/job/job-api.routes";
import http from "../../../../../shared/utils/http";

const AppliedJobs: React.FC = () => {
  const [jobs, setJobs] = useState<JobInfo[]>([]);

  useEffect(() => {
    http.get(JobApiRoutes.GET_APPLIED_JOBS).then((res) => {
      setJobs(res);
    }).catch(() => {
      // Handle error or set empty array
      setJobs([]);
    });
  }, []);

  return (
    <div className="grand-container">
      <div className="job_timeline_container">
        <p className="jobs__caption">Applied Jobs</p>
        <div className="job-timeline board-container">
          {jobs.length > 0 ? (
            jobs.map((job: JobInfo, index: number) => (
              <Job jobInfo={job} key={index} />
            ))
          ) : (
            <div className="empty-state">
              <p className="empty-state__message">You haven't applied for any job yet</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AppliedJobs;
